import { render, staticRenderFns } from "./dimmed.vue?vue&type=template&id=f28f306c&"
import script from "./dimmed.vue?vue&type=script&lang=js&"
export * from "./dimmed.vue?vue&type=script&lang=js&"
import style0 from "./dimmed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports